import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { atoms, sizes, Text, VStack } from '@rtkwlf/fenrir-react';
import { faExclamationCircle } from '@rtkwlf/pro-solid-svg-icons/faExclamationCircle';
import { useTranslation } from 'react-i18next';

export const NoScanExclusionData = () => {
  const { t } = useTranslation('telemetryScannerConfig');

  return (
    <VStack xAlign="center" width="full" style={{ minHeight: sizes['16rem'] }}>
      <FontAwesomeIcon
        size="3x"
        icon={faExclamationCircle}
        className={atoms({
          textColor: 'placeholder',
        })}
      />
      <Text styledAs="body2"> {t('scanExclusion.noScanExclusions')}</Text>
      <Text styledAs="body3">
        {t('scanExclusion.addScanExclusionDescriptionLine2')}
      </Text>
    </VStack>
  );
};
